var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pageHeader',{attrs:{"headerImg":_vm.config.headerImg,"headerTitle":_vm.config.headerTitle,"headerDesc":_vm.config.headerDesc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }